<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    let topicStatus = {"0":window.$t("other.topic.notStart"),"1":window.$t("other.topic.start"),"2":window.$t("other.topic.over")};
    let lang = {"en_US":window.$t("other.topic.en_US"),"vi_VN":window.$t("other.topic.vi_VN")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        mounted(){
          this.setAddOrUpdate();
        },
        methods: {
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              row.time = [row.startTime,row.endTime];
              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${Url.topic.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }else if(clickName == "practice"){
                this.$router.push({path:"/other/topic/commentsList", query: { topicId: row.id ,label:'OHTER'} })
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t("common.search") == clickName || "查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t("common.add")==clickName){
                    data.time = [data.startTime,data.endTime];
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                model.startTime = model.time[0];
                model.endTime = model.time[1];
                //根据是否包含id更新还是添加
                this.dataChanage(Url.topic.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })

            },
            setAddOrUpdate(){
                  this.updateData.cols = [
                    { title: '主键', field: 'id',hidden:true},
                    { title: window.$t("other.topic.titleName"), field: 'title',required:true},
                    {title:  window.$t("other.topic.startTime"), field: 'time', type: 9, format: 'yyyy-MM-dd HH:mm:ss',data:[],required:true},
                    { title: window.$t("other.topic.topicAbstract"), field: 'topicAbstract',required:true},
                    { title: window.$t("other.topic.lang"), field: 'lang',type:2,optionList:lang,required:true,data:'en_US'},
                    { title: window.$t("other.topic.productCode"), field: 'productCode',required:true},
                    { title: window.$t("other.topic.voteView"), field: 'voteView',required:true},
                    { title: window.$t("other.topic.supportCopy"), field: 'supportCopy',required:true},
                    { title: window.$t("other.topic.supportCount"), field: 'supportCount',type:7,required:true,data:0,min:0,precision:0},
                    { title: window.$t("other.topic.oppositionCopy"), field: 'oppositionCopy',required:true},
                    { title: window.$t("other.topic.oppositionCount"), field: 'oppositionCount',type:7,required:true,data:0,min:0,precision:0},
                    { title: window.$t("other.topic.topicDetail"), field: 'topicDetail',type:6,uploadUrl:Url.img.upload,required:true},
                  ]
            },
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t("other.topic.title"), field: 'title'},
                        { title: window.$t("other.topic.topicStatus"),field: 'topicStatus',type:2,optionList:topicStatus,isNumber:true},
                        { title: window.$t("other.topic.lang"), field: 'lang',type:2,optionList:lang},
                        {click:window.$t("common.search")},
                        {click:window.$t("common.add")},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.topic.query,
                    selection: false,
                    sequence: false,
                  method:"get",
                    cols: [
                        { title: 'ID', field: 'id'},
                        { title: window.$t("other.topic.titleName"), field: 'title'},
                        { title: window.$t("other.topic.topicStatus"), field: 'topicStatus',render:(data)=>{
                                return topicStatus[data];
                            }},
                        { title: window.$t("other.topic.lang"), field: 'lang',render:(data)=>{
                                return lang[data];
                            }},
                        { title: window.$t("other.topic.startTime"), field: 'startTime'},
                        { title: window.$t("other.topic.endTime"), field: 'endTime'},
                        { title: window.$t("other.topic.supportCount"), field: 'supportCount'},
                        { title: window.$t("other.topic.supportCountReal"), field: 'supportCountReal'},
                        { title: window.$t("other.topic.oppositionCount"), field: 'oppositionCount'},
                        { title: window.$t("other.topic.oppositionCountReal"), field: 'oppositionCountReal'},
                        { title: window.$t("other.topic.commentCount"), field: 'commentCount'},
                        {title: window.$t("common.handle"),width:'280px',btnClick:[
                          {
                            name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit"
                          },
                          {
                            name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete"
                          },
                            {
                              name:window.$t("other.topic.viewMessage"),click:"practice",type:"primary",icon:"el-icon-edit"
                            }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
